import { render, staticRenderFns } from "./NotBot.vue?vue&type=template&id=035a262b&scoped=true&"
import script from "./NotBot.vue?vue&type=script&lang=js&"
export * from "./NotBot.vue?vue&type=script&lang=js&"
import style0 from "./NotBot.vue?vue&type=style&index=0&id=035a262b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a262b",
  null
  
)

export default component.exports